import React, { useState } from 'react';
import { js_utils } from '../utils/frfr-js-utils';
import ColumnWidthMinimize from './ColumnWidthMinimize';
import JSDisplayValue from './JSDisplayValue';
import JSDisplayValueAsJsonField from './JSDisplayValueAsJsonField';
import JSDisplayWidgetCollapsibleHeight from './JSDisplayWidgetCollapsibleHeight';
import JSRapidoziBtn from './JSRapidoziBtn';


//
const _make_form_val_initial_state = (v) => {
  const initialState = {};
  initialState._initial_val = v;
  initialState.val_new = v;
  if (typeof v === "string") {
    initialState._typeis = "string";
  } else if (typeof v === "number") {
    initialState._typeis = "number";
  } else if (typeof v === "boolean") {
    initialState._typeis = "boolean";
  } else if (typeof v === "object") {
    if (v === null) {
      initialState._typeis = "null";
    } else {
      if (Array.isArray(v)) {
        initialState._typeis = "arr";
      } else {
        initialState._typeis = "obj";
      }
    }
  } else {
  }
  initialState._initial_type = initialState._typeis;
  return initialState;
};
//
const JSEditorFormVal = (props) => {
  const [state, setState] = useState(_make_form_val_initial_state(props.v));
  return (
    <div className="jsunicompo-jseditor__editable-element__new-val-form">
      <div>
        <form>
          <select
            className="frfr-js-rapidozi__input"
            value={state._typeis}
            onChange={(e) => {
              let val_new = null;
              let _new_type = e.target.value;
              if (_new_type === state._initial_type) { // TODO
                val_new = state._initial_val;
              }
              if (true) {
                if (_new_type === "null") {
                  val_new = null;
                } else if (_new_type === "string") {
                  val_new = "";
                } else if (_new_type === "number") {
                  val_new = 0;
                } else if (_new_type === "boolean") {
                  // val_new = false;
                  val_new = true;
                } else if (_new_type === "obj") {
                  val_new = {};
                } else if (_new_type === "arr") {
                  val_new = [];
                } else if (_new_type === "json") {
                  val_new = "";
                }
              }
              const updatedState = {
                ...state,
                _typeis: _new_type,
                val_new,
              };
              setState(updatedState);
            }}
          >
            <option value="null">null</option>
            <option value="string">string</option>
            <option value="number">number</option>
            <option value="boolean">boolean</option>
            <option value="obj">{'Object {}'}</option>
            <option value="arr">{'Array []'}</option>
            <option value="json">{'* JSON'}</option>
          </select>
        </form>
      </div>
      <div>
        <form>
          {
            state._typeis === "string" && (
              <input
                type="text"
                className="frfr-js-rapidozi__input"
                value={state.val_new}
                onChange={(e) => {
                  // setState(e.target.value);
                  setState({
                    ...state,
                    val_new: e.target.value
                  });
                }}
              />
            )
          }
          {
            state._typeis === "number" && (
              <input
                type="number"
                className="frfr-js-rapidozi__input"
                value={state.val_new}
                onChange={(e) => {
                  // setState(e.target.value);
                  let _val_new = Number.parseFloat(e.target.value);
                  setState({
                    ...state,
                    val_new: _val_new
                  });
                }}
              />
            )
          }
          {
            state._typeis === "boolean" && (
              <input
                type="checkbox"
                className="frfr-js-rapidozi__input"
                checked={state.val_new === true ? true : false}
                onChange={(e) => {
                  // setState(e.target.value);
                  const checked = e.target.checked === true ? true : false;
                  setState({
                    ...state,
                    val_new: checked
                  });
                }}
              />
            )
          }
          {
            state._typeis === "json" && (
              <div className="uniformcompo__field uniformcompo__field--no-yard">
                <textarea
                  className="frfr-js-rapidozi__input-json"
                  value={state.val_new}
                  onChange={(e) => {
                    // setState(e.target.value);
                    setState({
                      ...state,
                      val_new: e.target.value
                    });
                  }}
                />
              </div>
            )
          }
        </form>
      </div>
      <JSRapidoziBtn
        i="fa fa-floppy-o"
        title="Update"
        tooltip="Update value"
        themeCompoColorJseditor
        handleClick={() => {
          if (state._typeis === "json") {
            let error = true;
            let errorMsg = null;
            let decoded;
            const json = state.val_new;
            try {
              decoded = JSON.parse(json);
              error = false;
            } catch (error) {
              console.log(error);
              errorMsg = 'ERROR JSON is not valid!';
            }
            //
            if (error !== true) {
              const val_new = decoded;
              props.cbSubmitUpdatedVal(val_new);
            }
          } else {
            props.cbSubmitUpdatedVal(state.val_new);
          }
        }}
      />
    </div>
  );
};


//
const JSEditorFormKeyRename = (props) => {
  const [state, setState] = useState(props.k);
  return (
    <div className="jsunicompo-jseditor__editable-element__new-val-form">
      <div>
        <form>
          <input
            type="text"
            value={state}
            onChange={(e) => {
              setState(e.target.value);
            }}
          />
        </form>
      </div>
      <div>
        <JSRapidoziBtn
          i="fa fa-floppy-o"
          title={props.modeCreate ? "Add" : "Rename"}
          tooltip={props.modeCreate ? "Add new property" : "Rename key"}
          themeCompoColorJseditor
          handleClick={() => {
            if (props.modeCreate) {
              props.handleClickPropertyCreate(state);
            } else {
              props.handleClickPropertyKeyRename(props.k, state);
            }
          }}
        />
      </div>
    </div>
  );
};


//
const JSEditorKeyVal = (props) => {
  const handleKeyValPack = props.handleKeyValPack;
  const [state, setState] = useState({
    editingKey: false,
    // editingVal: false,
  });
  const handleClickEditingKey = () => {
    setState(state => {
      return {
        ...state,
        editingKey: true,
        // editingVal: false,
      };
    });
  };
  const handleClickCancelEditing = () => {
    setState(state => {
      return {
        ...state,
        editingKey: false,
        // editingVal: false,
      };
    });
  };
  const handleClickPropertyDelete = () => {
    handleKeyValPack.handleClickPropertyDelete(props.k);
    setState(state => {
      return {
        ...state,
        editingKey: false,
        // editingVal: false,
      };
    });
  };
  const handleClickPropertyCreate = (key_new) => {
    handleKeyValPack.handleClickPropertyCreate(key_new);
    setState(state => {
      return {
        ...state,
        editingKey: false,
        // editingVal: false,
      };
    });
  };
  const handleClickPropertyKeyRename = (key_old, key_new) => {
    handleKeyValPack.handleClickPropertyKeyRename(key_old, key_new);
    setState(state => {
      return {
        ...state,
        editingKey: false,
        // editingVal: false,
      };
    });
  };
  const handleClickPropertyValUpdate = (val_new) => {
    handleKeyValPack.handleClickPropertyValUpdate(props.k, val_new);
    setState(state => {
      return {
        ...state,
        editingKey: false,
        // editingVal: false,
      };
    });
  };
  //
  return (
    <tr className={""}>
      <th scope="row" className={props.modeArray ? "frfr-js-table__keyval-row__key-index" : "frfr-js-table__keyval-row__key"}>

        <div className="jsunicompo-jseditor__editable-element">
          <div className="jsunicompo-jseditor__editable-element__vector">
            <div>{props.modeCreate ? null : props.k}</div>
            <div className="jsunicompo-jseditor__editable-element__btns">
              {
                state.editingKey ? (
                  <JSRapidoziBtn
                    i="fa fa-window-close-o"
                    title="Cancel"
                    themeCompoColorJseditor
                    handleClick={() => {
                      handleClickCancelEditing();
                    }}
                  />
                ) : (
                  <>
                    {
                      props.modeArray ? (
                        props.modeCreate ? (
                          <JSRapidoziBtn
                            i={"fa fa-plus"}
                            tooltip="Add property/index"
                            themeCompoColorJseditor
                            handleClick={() => {
                              // handleClickEditingKey();
                              handleClickPropertyCreate();
                            }}
                          />
                        ) : (null)
                      ) : (
                        <JSRapidoziBtn
                          i={props.modeCreate ? "fa fa-plus" : "fa fa-pencil"}
                          tooltip={props.modeCreate ? "Add property" : "Edit key"}
                          themeCompoColorJseditor
                          handleClick={() => {
                            handleClickEditingKey();
                          }}
                        />
                      )
                    }
                    {
                      props.modeCreate !== true && (
                        <JSRapidoziBtn
                          i={"fa fa-trash"}
                          tooltip="Delete property"
                          themeCompoColorJseditor
                          handleClick={() => {
                            handleClickPropertyDelete();
                          }}
                        />
                      )
                    }
                  </>
                )
              }
            </div>
          </div>
          {
            state.editingKey && (
              <div className="jsunicompo-jseditor__editable-element__vector">
                <JSEditorFormKeyRename
                  modeCreate={props.modeCreate}
                  k={props.modeCreate ? 'new' : props.k}
                  handleClickPropertyKeyRename={handleClickPropertyKeyRename}
                  handleClickPropertyCreate={handleClickPropertyCreate}
                />
              </div>
            )
          }
        </div>

      </th>
      <td className="frfr-js-table__keyval-row__val">

        <div className="jsunicompo-jseditor__editable-element">
          <div className="jsunicompo-jseditor__editable-element__vector">
            <div>
              {
                props.modeCreate ? (null) : (
                  <JSEditorValueUniversal val={props.v} cbSetVal={handleClickPropertyValUpdate} />
                )
              }
            </div>
          </div>
        </div>

      </td>
    </tr>
  );
};


// SPECIAL
const JSDisplayObjectJSEditorObjAndArr = (props) => {
  let obj = props.val;
  /*
  let initialDisplayStyle = 0; // DEFAULT 0 Vertical list
  if (props.initialHorizontal === true) {
    initialDisplayStyle = 1;
  }
  const [displayStyle, setDisplayStyle] = useState(initialDisplayStyle); // 0 Vertical list, 1 Horizontal, 2 Tree mode
  */
  const displayStyle = 0;
  // console.log(Object.entries(obj));

  //
  //
  const cbSetVal = props.cbSetVal;
  const state = props.val;
  const setState = cbSetVal;
  //
  const handleClickPropertyDelete = (key_target) => {
    // setState(state => {
    if (js_utils.is_object(state)) {
      const updatedState = { ...state };
      delete updatedState[key_target];
      // return updatedState;
      setState(updatedState);
    } else if (Array.isArray(state)) {
      console.log('state', state);
      console.log('key_target', key_target, typeof key_target);
      const updatedState = state.filter((item, index) => {
        console.log(item, index);
        if (index === key_target || index === Number.parseFloat(key_target)) {
          return false; // remove from array
        }
        return true; // all other stay
      });
      // return updatedState;
      setState(updatedState);
    } else {
      // return state;
      // setState(state);
    }
    // });
  };
  //
  const handleClickPropertyCreate = (key_new) => {
    // setState(state => {
    if (js_utils.is_object(state) && !(key_new in state)) {
      const updatedState = { ...state };
      updatedState[key_new] = null;
      // return updatedState;
      setState(updatedState);
    } else if (Array.isArray(state)) {
      const updatedState = [...state, null];
      // return updatedState;
      setState(updatedState);
    } else {
      // return state;
      // setState(state);
    }
    // });
  };
  //
  const handleClickPropertyKeyRename = (key_old, key_new) => {
    // setState(state => {
    if (js_utils.is_object(state) && key_old in state && !(key_new in state)) {
      /*
      const temp_val = state[key_old];
      const updatedState = { ...state };
      updatedState[key_new] = temp_val;
      delete updatedState[key_old];
      */
      const updatedState = {};
      Object.keys(state).forEach(key => {
        if (key === key_old) {
          updatedState[key_new] = state[key_old];
        } else {
          updatedState[key] = state[key];
        }
      });
      // return updatedState;
      setState(updatedState);
    } else {
      // return state;
      // setState(state);
    }
    // });
  };
  //
  const handleClickPropertyValUpdate = (key, val_new) => {
    // setState(state => {
    if (js_utils.is_object(state) && key in state) {
      const updatedState = { ...state };
      updatedState[key] = val_new;
      // return updatedState;
      setState(updatedState);
    } else if (Array.isArray(state) && key in state) {
      const updatedState = [...state];
      updatedState[key] = val_new;
      // return updatedState;
      setState(updatedState);
    } else {
      // return state;
      // setState(state);
    }
    // });
  };
  //
  const handleKeyValPack = {
    handleClickPropertyDelete,
    handleClickPropertyCreate,
    handleClickPropertyKeyRename,
    handleClickPropertyValUpdate,
    // cbSetVal: props.cbSetVal,
  };
  //
  //

  return (
    <ColumnWidthMinimize>
      <div className="jsunicompo-display-object-widget jsunicompo-display-object-widget--editor">
        <div className="jsunicompo-display-object-widget__xi-header">
          {
            props.modeArray ? (
              <>
                <span className="jsunicompo-display-object-widget__xi-header__notation"><span>{'['}</span><span>{']'}</span></span><span className="jsunicompo-display-object-widget__xi-header_title">Array EDITOR</span>
              </>
            ) : (
              <>
                <span className="jsunicompo-display-object-widget__xi-header__notation"><span>{'{'}</span><span>{'}'}</span></span><span className="jsunicompo-display-object-widget__xi-header_title">Object EDITOR</span>
              </>
            )
          }
        </div>
        <div className="jsunicompo-display-object-widget__xi-body">

          <JSDisplayWidgetCollapsibleHeight>
            {
              js_utils.is_object(obj) || Array.isArray(obj) ? (
                <>
                  {
                    displayStyle === 0 && (
                      <table className="frfr-js-table frfr-js-table__keyval-list-vertical">
                        <thead>
                          <tr>
                            {
                              props.modeArray ? (
                                <th className="frfr-js-table__keyval-row__key-index"><span>index</span></th>
                              ) : (
                                <th className="frfr-js-table__keyval-row__key"><span>key</span></th>
                              )
                            }
                            <th className="frfr-js-table__keyval-row__val"><span>value</span></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            Object.entries(obj).map((el) => {
                              // console.log(el);
                              const key = el[0];
                              const value = el[1];
                              /*
                              return (
                                <tr key={key} className={""}>
                                  <th scope="row" className="frfr-js-table__keyval-row__key"><span>{key}</span></th>
                                  <td className="frfr-js-table__keyval-row__val"><JSDisplayValue val={value} cb={props.cb} primitive_validator={props.primitive_validator} key_name={key} /></td>
                                </tr>
                              );
                              */
                              return (
                                <JSEditorKeyVal
                                  key={key}
                                  modeArray={props.modeArray}
                                  k={key}
                                  v={value}
                                  handleKeyValPack={handleKeyValPack}
                                />
                              );
                            })
                          }
                          <JSEditorKeyVal
                            modeArray={props.modeArray}
                            modeCreate
                            k={null}
                            v={null}
                            handleKeyValPack={handleKeyValPack}
                          />
                        </tbody>
                      </table>
                    )
                  }
                </>
              ) : (
                <div className="jsunicompo-display-velue-error-msg"><span>ERROR: Value is not an Object!</span></div>
              )
            }
          </JSDisplayWidgetCollapsibleHeight>

        </div>
      </div>
    </ColumnWidthMinimize>
  );
};


// every value and subvalue...
const JSEditorValueUniversal = (props) => {
  const val = props.val;
  const [state, setState] = useState({
    // editingKey: false,
    editingVal: false,
    exportingVal: false,
  });
  const handleClickEditingVal = () => {
    setState(state => {
      return {
        ...state,
        // editingKey: false,
        editingVal: true,
        exportingVal: false,
      };
    });
  };
  const handleClickExportingVal = () => {
    setState(state => {
      return {
        ...state,
        // editingKey: false,
        editingVal: false,
        exportingVal: true,
      };
    });
  };
  const handleClickCancelEditing = () => {
    setState(state => {
      return {
        ...state,
        // editingKey: false,
        editingVal: false,
        exportingVal: false,
      };
    });
  };
  const cbSubmitUpdatedVal = (val_new) => {
    props.cbSetVal(val_new);
    setState(state => {
      return {
        ...state,
        // editingKey: false,
        editingVal: false,
        exportingVal: false,
      };
    });
  };
  //
  let what = null;
  if (js_utils.is_object(val)) {
    what = "obj";
  } else if (Array.isArray(val)) {
    what = "arr";
    /*
  } else if (val === null || typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
    what = "PRIMITIVE";
    */
  } else {
    // what = "OTHER";
    what = null;
  }
  //
  return (
    <>
      <div className="jsunicompo-jseditor__editable-element">
        <div className="jsunicompo-jseditor__editable-element__vector">
          <div className={"" + (state.editingVal ? "jsunicompo-jseditor__editable-element__old-val" : "")}>
            {
              what === "obj" && (
                <JSDisplayObjectJSEditorObjAndArr val={val} modeArray={false} cbSetVal={props.cbSetVal} />
              )
            }
            {
              what === "arr" && (
                <JSDisplayObjectJSEditorObjAndArr val={val} modeArray={true} cbSetVal={props.cbSetVal} />
              )
            }
            {
              /*
              what === "PRIMITIVE" && (
                <JSEditorPrimitiveVal val={val} cbSetVal={props.cbSetVal} />
              )
              */
              what === null && (
                <JSDisplayValue val={val} />
              )
            }
            {
              /*
              what === null && (
                <p>JSUniValueEditor OTHER</p>
              )
              */
            }
          </div>
          <div className="jsunicompo-jseditor__editable-element__btns">
            {
              (
                state.editingVal || state.exportingVal ? (
                  <JSRapidoziBtn
                    i="fa fa-window-close-o"
                    title="Cancel"
                    themeCompoColorJseditor
                    handleClick={() => {
                      handleClickCancelEditing();
                    }}
                  />
                ) : (
                  <>
                    <JSRapidoziBtn
                      i="fa fa-pencil"
                      tooltip="Edit value"
                      themeCompoColorJseditor
                      handleClick={() => {
                        handleClickEditingVal();
                      }}
                    />
                    <JSRapidoziBtn
                      i="fa fa-download"
                      tooltip="Export value"
                      themeCompoColorJseditor
                      handleClick={() => {
                        handleClickExportingVal();
                      }}
                    />
                  </>
                )
              )
            }
          </div>
        </div>
        {
          state.editingVal && (
            <div className="jsunicompo-jseditor__editable-element__vector">
              <JSEditorFormVal
                v={val}
                cbSubmitUpdatedVal={cbSubmitUpdatedVal}
              />
            </div>
          )
        }
        {
          state.exportingVal && (
            <div className="jsunicompo-jseditor__editable-element__vector">
              <JSDisplayValueAsJsonField val={val} btnCopyEnabled={true} />
            </div>
          )
        }
      </div>
    </>
  );
};


// DEFAULT COMPONENT
const JSUniValueEditor = (props) => {
  // const val = props.val;
  let cbSetVal = () => { };
  if (typeof props.cbSetVal === 'function') {
    cbSetVal = props.cbSetVal;
  }
  //
  return (
    <div className="jsunicompo-jseditor">
      <div className="jsunicompo-jseditor__header">
        <div>JS/JSON Value Editor</div>
      </div>
      <div className="jsunicompo-jseditor__body">
        {/*
        <div>enable renaming keys</div>
        <div>enable adding new keys</div>
        */}
        <JSEditorValueUniversal val={props.val} cbSetVal={cbSetVal} />
      </div>
    </div>
  );
};

export default JSUniValueEditor;